 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"lang-ch-ts":"lang-ch-ts","lang-en-ts":"lang-en-ts"}[chunkId]||chunkId) + "." + {"chunk-17641a22":"b26eb291","chunk-2d0b2d29":"c72fcf5e","chunk-2d22d7a9":"edb10dba","chunk-5cc1832d":"514c2ac4","chunk-17c1517e":"62d0dcfe","chunk-bb79128e":"d464b217","chunk-5ef7677e":"f11f0ffc","chunk-2d0b28ce":"8b64cbe7","chunk-8c0c404c":"1843850c","chunk-8c10c1d6":"b3cacb85","chunk-098cd01a":"87feced2","chunk-1483f525":"ade991c1","chunk-155b8ed4":"c1770012","chunk-29372fa4":"8d30f0c7","chunk-70b03975":"bee619b1","chunk-0f164a8d":"4c79982a","chunk-2d0bd205":"af1e1344","chunk-00f36044":"8cd9fce6","chunk-03136ad0":"10b56897","chunk-29b805c6":"46d5d896","chunk-31629130":"f241061d","chunk-723c95ee":"66f9a885","chunk-40b5a21c":"44af964c","chunk-4ecf24cc":"71f23e6f","chunk-6298a2b0":"602a1e6a","chunk-62695668":"30e41394","chunk-74696b36":"135c078c","chunk-62b30220":"94664620","chunk-63b702b3":"bbee9dda","chunk-644345d5":"3307a9d9","chunk-65747e5f":"6b15b103","chunk-af3e823a":"5eea5492","chunk-0b9a356a":"ff3177fb","chunk-eba09d4e":"76c86c21","chunk-f3fd8b46":"19f085f7","chunk-5c8e4dcc":"6c732714","chunk-4391f028":"de8af4f9","chunk-4df06d4c":"56e4be5e","chunk-55c42210":"f71cf63e","chunk-960c1284":"a2c3e2c8","chunk-f38ef6ba":"ffc71d89","lang-ch-ts":"4aed3ffc","lang-en-ts":"e1a01d30","chunk-2d217a0d":"aa6cc8d3","chunk-beb34dce":"21cf2bf8","chunk-0e7d798c":"89b59a28","chunk-5f3bd499":"a98b1b48","chunk-6d5a2c88":"46ac2c60","chunk-7f0d7215":"f4ce0337","chunk-1b82f5ec":"52c80eb2","chunk-3098f2c5":"4997fbeb","chunk-877e912e":"640d9c30","chunk-8ac690ca":"2370e4e8","chunk-e8395464":"90934737","chunk-df0a5ed2":"3181480b","chunk-2d0c05f4":"fb26bf11","chunk-2d0c1929":"edb9c208","chunk-2d0ce74f":"5d77d0b1","chunk-2d0dd440":"33883dfc","chunk-2d0ddc7a":"9c45b03c","chunk-2d0ddd68":"a2428c3f","chunk-2d0df408":"d46d1e3d","chunk-2d0e2532":"6d5f4737","chunk-2d0e48be":"8574ae5e","chunk-2d0e508a":"aea574c2","chunk-2d21060f":"aac1459b","chunk-2d22c124":"7d84054d","chunk-5f8b5f70":"10488df5","chunk-6d3b6cb8":"0e3dfeb2","chunk-70ea9fe4":"e80b6951","chunk-745fee07":"9addfd00","chunk-96b8201e":"253d4285","chunk-2d0a3ffb":"fa488dc8","chunk-31f11ff2":"fcfd90e1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-17641a22":1,"chunk-5cc1832d":1,"chunk-17c1517e":1,"chunk-5ef7677e":1,"chunk-8c0c404c":1,"chunk-8c10c1d6":1,"chunk-098cd01a":1,"chunk-1483f525":1,"chunk-155b8ed4":1,"chunk-29372fa4":1,"chunk-70b03975":1,"chunk-0f164a8d":1,"chunk-00f36044":1,"chunk-03136ad0":1,"chunk-29b805c6":1,"chunk-31629130":1,"chunk-723c95ee":1,"chunk-40b5a21c":1,"chunk-4ecf24cc":1,"chunk-6298a2b0":1,"chunk-62b30220":1,"chunk-63b702b3":1,"chunk-644345d5":1,"chunk-65747e5f":1,"chunk-0b9a356a":1,"chunk-eba09d4e":1,"chunk-f3fd8b46":1,"chunk-5c8e4dcc":1,"chunk-4391f028":1,"chunk-4df06d4c":1,"chunk-55c42210":1,"chunk-960c1284":1,"chunk-f38ef6ba":1,"chunk-beb34dce":1,"chunk-0e7d798c":1,"chunk-5f3bd499":1,"chunk-6d5a2c88":1,"chunk-7f0d7215":1,"chunk-1b82f5ec":1,"chunk-3098f2c5":1,"chunk-877e912e":1,"chunk-8ac690ca":1,"chunk-e8395464":1,"chunk-df0a5ed2":1,"chunk-6d3b6cb8":1,"chunk-70ea9fe4":1,"chunk-96b8201e":1,"chunk-31f11ff2":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"lang-ch-ts":"lang-ch-ts","lang-en-ts":"lang-en-ts"}[chunkId]||chunkId) + "." + {"chunk-17641a22":"0bb98451","chunk-2d0b2d29":"31d6cfe0","chunk-2d22d7a9":"31d6cfe0","chunk-5cc1832d":"849bd528","chunk-17c1517e":"06a8f34e","chunk-bb79128e":"31d6cfe0","chunk-5ef7677e":"5693aea0","chunk-2d0b28ce":"31d6cfe0","chunk-8c0c404c":"ce77675d","chunk-8c10c1d6":"ce77675d","chunk-098cd01a":"dfc74237","chunk-1483f525":"dfc74237","chunk-155b8ed4":"dfc74237","chunk-29372fa4":"2efee817","chunk-70b03975":"c300c873","chunk-0f164a8d":"5a3cd893","chunk-2d0bd205":"31d6cfe0","chunk-00f36044":"5470944f","chunk-03136ad0":"dd84923a","chunk-29b805c6":"2e4c0a74","chunk-31629130":"7efa81cf","chunk-723c95ee":"4f33a68c","chunk-40b5a21c":"5a28c9c9","chunk-4ecf24cc":"8038f23e","chunk-6298a2b0":"dfc74237","chunk-62695668":"31d6cfe0","chunk-74696b36":"31d6cfe0","chunk-62b30220":"dfc74237","chunk-63b702b3":"dfc74237","chunk-644345d5":"dfc74237","chunk-65747e5f":"dfc74237","chunk-af3e823a":"31d6cfe0","chunk-0b9a356a":"b7eba38c","chunk-eba09d4e":"dfc74237","chunk-f3fd8b46":"dfc74237","chunk-5c8e4dcc":"a9fdc943","chunk-4391f028":"dfc74237","chunk-4df06d4c":"dfc74237","chunk-55c42210":"dfc74237","chunk-960c1284":"dfc74237","chunk-f38ef6ba":"23797624","lang-ch-ts":"31d6cfe0","lang-en-ts":"31d6cfe0","chunk-2d217a0d":"31d6cfe0","chunk-beb34dce":"f65ac7fb","chunk-0e7d798c":"35e9df35","chunk-5f3bd499":"251be634","chunk-6d5a2c88":"ca1f0fd2","chunk-7f0d7215":"5725dfc1","chunk-1b82f5ec":"d1e3a4d6","chunk-3098f2c5":"74877922","chunk-877e912e":"1253b834","chunk-8ac690ca":"c9449800","chunk-e8395464":"4ef4a30e","chunk-df0a5ed2":"217b24ef","chunk-2d0c05f4":"31d6cfe0","chunk-2d0c1929":"31d6cfe0","chunk-2d0ce74f":"31d6cfe0","chunk-2d0dd440":"31d6cfe0","chunk-2d0ddc7a":"31d6cfe0","chunk-2d0ddd68":"31d6cfe0","chunk-2d0df408":"31d6cfe0","chunk-2d0e2532":"31d6cfe0","chunk-2d0e48be":"31d6cfe0","chunk-2d0e508a":"31d6cfe0","chunk-2d21060f":"31d6cfe0","chunk-2d22c124":"31d6cfe0","chunk-5f8b5f70":"31d6cfe0","chunk-6d3b6cb8":"6f68a63d","chunk-70ea9fe4":"44056fe2","chunk-745fee07":"31d6cfe0","chunk-96b8201e":"d78a4574","chunk-2d0a3ffb":"31d6cfe0","chunk-31f11ff2":"f1ab26a3"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
